var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThreeDots = function SvgThreeDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.8,
    d: "M6 6.5c.255 0 .462-.224.462-.5S6.255 5.5 6 5.5s-.461.224-.461.5.206.5.461.5M9.23 6.5c.256 0 .462-.224.462-.5s-.206-.5-.461-.5-.462.224-.462.5.207.5.462.5M2.769 6.5c.255 0 .462-.224.462-.5s-.207-.5-.462-.5-.462.224-.462.5.207.5.462.5"
  })));
};
export default SvgThreeDots;